export default __webpack_public_path__ + "static/media/is.89be1b71.svg";